export const PROCEED_EVENT_NAME = 'proceed'
export const LOAD_EVENT_NAME = 'load'
export const DEFAULT_TITLE_KEY = 'name'
export const DEFAULT_VALUE_KEY = 'id'
